// Query-key factory for the global entity Review Queue (Party Surfaces F7,
// /collection/review-queue). Required by the stale-after-save gate (queryKey
// literals must live in *Keys factory files).

import type { ReviewQueueEntitiesQuery } from "./collectionReviewQueue";

// Offset/limit ride the infinite query's pageParam, not the key.
export type ReviewQueueEntitiesKeyParams = Omit<
  ReviewQueueEntitiesQuery,
  "offset" | "limit"
>;

export const collectionReviewQueueKeys = {
  all: ["collection-review-queue"] as const,
  entities: (params: ReviewQueueEntitiesKeyParams) =>
    ["collection-review-queue", "entities", params] as const,
};
